import { render, staticRenderFns } from "./ModalCreateFormat.vue?vue&type=template&id=072d56bf"
import script from "./ModalCreateFormat.vue?vue&type=script&lang=ts"
export * from "./ModalCreateFormat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports